export default class PermissionsService {
  // This seems like it could be a static, but it's actually easier to use if it's not static
  PERMISSIONS = {
    BUYER_ADMIN: 'ROLE_BUYER_ADMIN',
    BUYER_EDIT_ORG_PROFILE: 'ROLE_BUYER_ORG_PROFILE_EDIT',
    BUYER_SEND_RFP: 'ROLE_BUYER_RFP_SEND',
    BUYER_PURCHASE_PLAN_EDIT: 'ROLE_BUYER_PURCHASE_PLAN_EDIT',
    BUYER_VIEW_PARTNER_DETAIL: 'BUYER_VIEW_PARTNER_DETAIL',
    BUYER_CPA_EXECUTE: 'ROLE_BUYER_CPA_EXECUTE',
    VIEW_PREVIEW_SPEND_HISTORY: 'VIEW_PREVIEW_SPEND_HISTORY',
    VIEW_ACTIVE_SPEND_HISTORY: 'VIEW_ACTIVE_SPEND_HISTORY'
  };

  constructor(private $http) {
    'ngInject';
  }

  /**
   * Get Permissions
   *
   * By default, gets the permissions for the org
   * To get the permissions for the group, pass in the group id
   */
  getPermissions(groupId?: number): ng.IPromise<any> {
    var url = '/aptitude/api/permissions';

    if (groupId) {
      url += '?groupId=' + groupId;
    }

    return this.$http.get(url);
  }
}
